module.exports = global["jQuery"] = require("-!/home/gial/dev/KAV_pages/node_modules/source-map-loader/index.js!/home/gial/dev/KAV_pages/node_modules/source-map-loader/index.js!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/source-map-loader!./~/jquery/dist/jquery.js-exposed
// module id = 3
// module chunks = 0